import { defineStore } from 'pinia';

export const useLanguageStore = defineStore('language', {
  state: () => ({
    language: 'de' as 'en' | 'de', 
  }),
  actions: {
    setLanguage(lang: 'de' | 'en') {
      this.language = lang;
    }
  },
});